import {
  Autocomplete, Box, Dialog, IconButton, setRef, Skeleton,
  Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip,
  Typography
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  ADD, AXIS_OPTIONS, BCDVA_OPTIONS, BCNVA,
  COMMON_STYLE, CYL_OPTIONS, PHVA_OPTION, SPH_OPTIONS,
  UCNVA_OPTIONS, UCVA_OPTIONS
} from '../../../../Utility/Constants';
import ShowComponents from '../../DoctorNotes/Common/ShowComponent';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import CloseIcon from '@mui/icons-material/Close';

const UmaSubRefraction = React.forwardRef((props, ref) => {
  const [subRef, setSubRef] = useState({
  subRefData: [],
  patient_details: {},
  clinic_id: '',
  appointment_id: '',
  patient_id: '',
  UCVAList: UCVA_OPTIONS,
  SPHList: SPH_OPTIONS,
  CYLList: CYL_OPTIONS,
  AXISList: AXIS_OPTIONS,
  BCDVAList: BCDVA_OPTIONS,
  UCNVAList: UCNVA_OPTIONS,
  ADDList: ADD,
  BCNVAList: BCNVA,
  PHVAList: PHVA_OPTION,
  subRefComments: '',
  loadScreen: false,
  prevSubRefComments: '',
  prevSubRefData: [],
  openComparePopup: false,
  enableCompare: false,
  enableCopy: false,
  dupSubRefComments: '',
  dupSubRefData: '[]'
})
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - SUBJECTIVE REFRACTION`,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - SUBJECTIVE REFRACTION`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  React.useImperativeHandle(ref, () => ({
    performSubRefractionAction: () => {
      if ((JSON.stringify(subRef.subRefData) !== subRef.dupSubRefData) || JSON.stringify(subRef.subRefComments) !== subRef.dupSubRefComments) {
        postSubRefractionData()
      }
    }
  }))

  const apicalls = async () => {
    await getSubRefractionData()
    await getPrevSubRefractionData()
  }

  useEffect(() => {
    if (subRef.subRefData && subRef.prevSubRefData) {
      let copy = subRef.prevSubRefData?.length > 0 ? subRef.prevSubRefData?.some((item) => (item?.UCVA !== '' || item?.SPH !== '' || item?.CYL ||
        item?.AXIS !== '' || item?.BCDVA !== '' || item?.UCNVA !== '' || item?.add !== '' || item?.BCNVA !== '' || item?.PHVA !== '')) : false
      let compare = subRef.subRefData?.length > 0 ? subRef.subRefData?.some((item) => (item?.UCVA !== '' || item?.SPH !== '' || item?.CYL ||
        item?.AXIS !== '' || item?.BCDVA !== '' || item?.UCNVA !== '' || item?.add !== '' || item?.BCNVA !== '' || item?.PHVA !== '')) : false
      setSubRef((prev) => ({
        ...prev,
        enableCompare: compare,
        enableCopy: copy
      }))
    }
  }, [subRef.subRefData, subRef.prevSubRefData])

  const getSubRefractionData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_SUB_REFRACTION + '?appointment_id=' + props.props.appointment_id + '&doctor_id=' + props?.props?.doctorID)
      if (response?.data?.status === 'success') {
        let subjRefData = [
          {
            "eye_type": "RE", "SPH": "", "CYL": "", "AXIS": "", "BCDVA": "", "UCNVA": "", "BCNVA": "", "add": "",
            "PHVA": "", "UCVA": "", "UC": "", "VA": "", "Aided_NV": "", "Aided_DV": "", "UnAided_NV": "", "UnAided_DV": "",
          },
          {
            "eye_type": "LE", "SPH": "", "CYL": "", "AXIS": "", "BCDVA": "", "UCNVA": "", "BCNVA": "", "add": "",
            "PHVA": "", "UCVA": "", "UC": "", "VA": "", "Aided_NV": "", "Aided_DV": "", "UnAided_NV": "", "UnAided_DV": "",
          },
        ]
        let subjRef = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        setSubRef((prev) => ({
          ...prev,
          subRefData: Object.keys(subjRef)?.length > 0 ? subjRef?.subref : subjRefData,
          subRefComments: Object.keys(subjRef)?.length > 0 ? subjRef?.comment : '',
          dupSubRefData: Object.keys(subjRef)?.length > 0 ? JSON.stringify(subjRef?.subref) : JSON.stringify(subjRefData),
          dupSubRefComments: Object.keys(subjRef)?.length > 0 ? JSON.stringify(subjRef?.comment) : JSON.stringify(''),
        }))
        props.subjectiveRefractionData(subjRef?.subref || [])
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error?.message)
      }
    }
  }

  const getPrevSubRefractionData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_SUB_REFRACTION_COPY +
        '?appointment_id=' + props?.props?.appointment_id + '&patient_id=' + props.props?.patient_id + '&doctor_id=' + props?.props?.doctorID
      )
      if (response?.data?.status === 'success') {
        let subjRef = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        setSubRef((prev) => ({
          ...prev,
          prevSubRefData: Object.keys(subjRef)?.length > 0 ? subjRef?.subref : [],
          prevSubRefComments: Object.keys(subjRef)?.length > 0 ? subjRef?.comment : '',
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error?.message)
      }
    }
  }

  const postSubRefractionData = async () => {
    try {
      let data = {
        appointment_id: props?.props?.appointment_id,
        comment: subRef.subRefComments,
        subref: subRef.subRefData
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_SUB_REFRACTION)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getSubRefractionData()
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error?.message)
      }
    }
  }

  const autocompleteTextBox = (names, values, options = [], optionLabel, placeholders, index) => {
    try {
      return (
        <Autocomplete
          disabled={props?.props?.patient_transfered || props?.props?.isLocked}
          clearIcon
          size='small'
          sx={{ width: '7dvw' }}
          value={values || ""}
          options={options}
          getOptionLabel={(option) => typeof (option) === 'string' ? option : option[optionLabel] || ""}
          onChange={(e, newValue) => {
            let subRefData = [...subRef.subRefData]
            subRefData[index] = { ...subRefData[index], [names]: newValue ? newValue?.label || "" : "" }
            setSubRef((prev) => ({ ...prev, subRefData: subRefData }))
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={placeholders}
              InputProps={{
                ...params.InputProps,emed_tid:{names},
                style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
              }}
            />
          )}
        />
    )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderComparePopup = () => {
    try {
      return (
        <Dialog open={subRef.openComparePopup} maxWidth="md" fullWidth>
          <Box className='doc_addendum_popup'>
            <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
              <Typography className='doc_notes_header_card_font'>Compare Subjective Refractive</Typography>
              <IconButton emed_tid='cmp_prev_cls'
                onClick={() => setSubRef((prev) => ({ ...prev, openComparePopup: false }))}><CloseIcon /></IconButton>
            </Box>
            <Box component={'div'} p={'0.5rem'}>
              <Box component={'div'} display={'flex'} alignItems={'center'}>
                <Typography className='doc_notes_header_card_font'>Current Subjective Refractive</Typography>
                <Tooltip placement='top' arrow title={'Copy'}>
                  <IconButton className='Common_Btn_Min_Width' sx={{ height: '3dvh' }} emed_tid='prev_cmp_cpy'
                    onClick={() => {
                      setSubRef((prev) => ({
                        ...prev,
                        subRefData: subRef.prevSubRefData,
                        subRefComments: subRef.prevSubRefComments,
                        openComparePopup: false
                      }))
                    }}
                  ><ContentCopyIcon color={'primary'} /></IconButton></Tooltip>
              </Box>
              <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                      {/* <TableCell className='doc_notes_tbl_header'>UCVA</TableCell> */}
                      <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                      <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                      <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                      <TableCell className='doc_notes_tbl_header'>BCDVA</TableCell>
                      {/* <TableCell className='doc_notes_tbl_header'>UCNVA</TableCell> */}
                      <TableCell className='doc_notes_tbl_header'>ADD</TableCell>
                      <TableCell className='doc_notes_tbl_header'>BCNVA</TableCell>
                      <TableCell className='doc_notes_tbl_header'>PHVA</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {subRef.prevSubRefData?.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.eye_type}</TableCell>
                          {/* <TableCell className='doc_notes_tbl_body_cell'>{item.UCVA}</TableCell> */}
                          <TableCell className='doc_notes_tbl_body_cell'>{item.SPH}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.CYL}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.AXIS}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.BCDVA}</TableCell>
                          {/* <TableCell className='doc_notes_tbl_body_cell'>{item.UCNVA}</TableCell> */}
                          <TableCell className='doc_notes_tbl_body_cell'>{item.add}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.BCNVA}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.PHVA}</TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Box>
            <Box component={'div'} p={'0.5rem'}>
              <Typography className='doc_notes_header_card_font'>New Subjective Refractive</Typography>
              <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                      {/* <TableCell className='doc_notes_tbl_header'>UCVA</TableCell> */}
                      <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                      <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                      <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                      <TableCell className='doc_notes_tbl_header'>BCDVA</TableCell>
                      {/* <TableCell className='doc_notes_tbl_header'>UCNVA</TableCell> */}
                      <TableCell className='doc_notes_tbl_header'>ADD</TableCell>
                      <TableCell className='doc_notes_tbl_header'>BCNVA</TableCell>
                      <TableCell className='doc_notes_tbl_header'>PHVA</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {subRef.subRefData?.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.eye_type}</TableCell>
                          {/* <TableCell className='doc_notes_tbl_body_cell'>{item.UCVA}</TableCell> */}
                          <TableCell className='doc_notes_tbl_body_cell'>{item.SPH}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.CYL}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.AXIS}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.BCDVA}</TableCell>
                          {/* <TableCell className='doc_notes_tbl_body_cell'>{item.UCNVA}</TableCell> */}
                          <TableCell className='doc_notes_tbl_body_cell'>{item.add}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.BCNVA}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item.PHVA}</TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Box>
          </Box>
        </Dialog >
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  return (
    <ShowComponents onIntersection={apicalls}>
      <Box component={'div'}>
        <Box component={'div'}>
          <Box component={'div'} className='doc_notes_header_card' display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
            <Typography className='doc_notes_header_card_font'>Subjective Refraction</Typography>
            <Box component={'div'} display={'flex'} alignItems={'center'}>
              <Tooltip placement='top' arrow title={'Copy'}><IconButton className='Common_Btn_Min_Width' emed_tid='sub_cpy'
                disabled={!subRef.enableCopy || props?.props?.patient_transfered || props?.props?.isLocked}
                onClick={() => {
                  setSubRef((prev) => ({
                    ...prev,
                    subRefData: subRef.prevSubRefData
                  }))
                }}
              ><ContentCopyIcon color={!subRef.enableCopy ? '' : 'primary'} /></IconButton></Tooltip>
              <Tooltip placement='top' arrow title={'View'}><IconButton className='Common_Btn_Min_Width' emed_tid='sub_cmp'
                disabled={!(subRef.enableCopy && subRef.enableCompare) || props?.props?.patient_transfered || props?.props?.isLocked}
                onClick={() => setSubRef((prev) => ({ ...prev, openComparePopup: true }))}
              ><VisibilityIcon color={!(subRef.enableCopy && subRef.enableCompare) ? '' : 'primary'} /></IconButton></Tooltip>
            </Box>
          </Box>
          <Box component={'div'} m={'0.5rem'}>
            <Box component={'div'} border={'1px solid lightgray'} m={'0.5rem 0rem'}>
              <Table size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                    {/* <TableCell className='doc_notes_tbl_header'>UCVA</TableCell> */}
                    <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                    <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                    <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                    <TableCell className='doc_notes_tbl_header'>BCDVA</TableCell>
                    {/* <TableCell className='doc_notes_tbl_header'>UCNVA</TableCell> */}
                    <TableCell className='doc_notes_tbl_header'>ADD</TableCell>
                    <TableCell className='doc_notes_tbl_header'>BCNVA</TableCell>
                    <TableCell className='doc_notes_tbl_header'>PHVA</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {subRef.subRefData?.length > 0 ? subRef.subRefData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                        {/* <TableCell className='doc_notes_tbl_body_cell'>
                          {autocompleteTextBox('UCVA', item?.UCVA, subRef?.UCVAList, 'label', 'UCVA', index)}
                        </TableCell> */}
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {autocompleteTextBox('SPH', item?.SPH, subRef?.SPHList, 'label', 'SPH', index)}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {autocompleteTextBox('CYL', item?.CYL, subRef?.CYLList, 'label', 'CYL', index)}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {autocompleteTextBox('AXIS', item?.AXIS, subRef?.AXISList, 'label', 'AXIS', index)}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {autocompleteTextBox('BCDVA', item?.BCDVA, subRef?.BCDVAList, 'label', 'BCDVA', index)}
                        </TableCell>
                        {/* <TableCell className='doc_notes_tbl_body_cell'>
                          {autocompleteTextBox('UCNVA', item?.UCNVA, subRef?.UCNVAList, 'label', 'UCNVA', index)}
                        </TableCell> */}
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {autocompleteTextBox('add', item?.add, subRef?.ADDList, 'label', 'ADD', index)}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {autocompleteTextBox('BCNVA', item?.BCNVA, subRef?.BCNVAList, 'label', 'BCNVA', index)}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {autocompleteTextBox('PHVA', item?.PHVA, subRef?.PHVAList, 'label', 'PHVA', index)}
                        </TableCell>
                      </TableRow>
                    )
                  }) : <TableRow><TableCell align='center' colSpan={10}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                </TableBody>
              </Table>
            </Box>
            <Box component={'div'}>
              <TextField
                disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                size='small'
                multiline
                fullWidth
                maxRows={5}
                value={subRef.subRefComments}
                onChange={(e) => {
                  let value = e.target.value
                  if(value?.length <= COMMON_STYLE.CHAR_LIMIT_DESP || value === ''){
                    setSubRef((prev) => ({ ...prev, subRefComments: value }))
                  }
                }}
                placeholder='Overall Comments'
                inputProps={{ maxLength: COMMON_STYLE.CHAR_LIMIT_DESP }}
              />
            </Box>
          </Box>
        </Box>
        {renderComparePopup()}
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
      </Box>
    </ShowComponents>
  )
})

export default UmaSubRefraction